import react from "react";
function footer(){



    return(
        <div className="footer" style={{backgroundColor:"blanchedalmond", textAlign:"center", padding:"5rem"}}>
            <h4 style={{ color:"red" }}>We do not issue government documents cards. We only assist or demo form in filling and submitting official applications </h4>
            <p>&copy; 2025 All rights reserved.</p>
        </div>
    );
}

export default footer;
